import {
  JsonFormsProps,
  JsonFormsCellRendererRegistryEntry,
  JsonFormsRendererRegistryEntry,
  rankWith,
  CellProps,
} from '@jsonforms/core';
import { withJsonFormsCellProps, withJsonFormsRendererProps } from '@jsonforms/react';
import { RENDERER_RANK_LAST_RESORT } from '../constants';

const reportUnsupportedElement = (props: Partial<JsonFormsProps | CellProps>) => {
  // throw detailed message for logging broken form element
  throw new Error(`Unsupported dynamic form element detected:
      Element path: ${props.path}
      Data Schema Title: ${props.schema?.title}
      Data Schema Type: ${props.schema?.type}
      UI Schema Type: ${props.uischema?.type}
    `);
};

export const UnsupportedRenderer: JsonFormsRendererRegistryEntry & JsonFormsCellRendererRegistryEntry = {
  tester: rankWith(
    RENDERER_RANK_LAST_RESORT,
    (_anyUiSchema, _anyDataSchema, _anyContext) => true // will match anything as last resort
  ),
  renderer: withJsonFormsRendererProps(reportUnsupportedElement),
  cell: withJsonFormsCellProps(reportUnsupportedElement),
};
